export default {
  wrapper: {
    margin: [0, 'auto', 40],
  },
};
